import { put, call } from 'redux-saga/effects';
import ActionTypes from '../actions/types';
import trainingServices from '../services/trainingServices';

function* getWorkoutsSaga(request) {
  console.log('getWorkoutsSaga(): ', request);
  try {
    const response = yield call(trainingServices.getWorkouts, request);
    yield put({ type: ActionTypes.GET_WORKOUTS_SUCCESS, response });
  } catch (error) {
    yield put({ type: ActionTypes.GET_WORKOUTS_FAIL, error });
  }
}

function* getWorkoutSaga(request) {
  console.log('getWorkoutSaga(): ', request);
  try {
    const response = yield call(trainingServices.getWorkout, request);
    yield put({ type: ActionTypes.GET_WORKOUT_SUCCESS, response });
  } catch (error) {
    yield put({ type: ActionTypes.GET_WORKOUT_FAIL, error });
  }
}

function* getExercisesSaga(request) {
  console.log('getExercisesSaga(): ', request);
  try {
    const response = yield call(trainingServices.getExercises, request);
    yield put({ type: ActionTypes.GET_EXERCISES_SUCCESS, response });
  } catch (error) {
    yield put({ type: ActionTypes.GET_EXERCISES_FAIL, error });
  }
}

const trainingSagas = {
  getWorkoutsSaga,
  getWorkoutSaga,
  getExercisesSaga,
};

export default trainingSagas;
